export type TriplePlayMaybe<T> = T | null;

export type TriplePlayMakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: TriplePlayMaybe<T[SubKey]> };
export type TriplePlayMakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: TriplePlayMaybe<T[SubKey]> };
/** All built-in and custom TriplePlayScalars, mapped to their actual values */
export type TriplePlayScalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  UUID: any;
  DateTime: any;
  Decimal: any;
};

export type TriplePlaySustainabilityScore = {
  __typename?: 'SustainabilityScore';
  source: TriplePlayScalars['String'];
  score: TriplePlayScalars['Decimal'];
};

export type TriplePlaySellingPoint = {
  __typename?: 'SellingPoint';
  id: TriplePlayScalars['UUID'];
  entityType: TriplePlayScalars['String'];
  creationDateTime?: TriplePlayMaybe<TriplePlayScalars['DateTime']>;
  lastModifiedBy?: TriplePlayMaybe<TriplePlayScalars['String']>;
  lastModifiedDateTime?: TriplePlayMaybe<TriplePlayScalars['DateTime']>;
  TriplePlayProductCategory: TriplePlayProductCategory;
  orderType: TriplePlayOrderType;
  sellingPointType: TriplePlaySellingPointType;
  clientName?: TriplePlayMaybe<TriplePlayScalars['String']>;
  description?: TriplePlayMaybe<TriplePlayScalars['String']>;
  value?: TriplePlayMaybe<TriplePlayScalars['String']>;
  version?: TriplePlayMaybe<TriplePlayScalars['Int']>;
};

export enum TriplePlayOrderType {
  Affiliate = 'AFFILIATE',
  FunnelMga = 'FUNNEL_MGA',
  NotOrderable = 'NOT_ORDERABLE',
}

export enum TriplePlaySellingPointType {
  UniqueSellingPoint = 'UNIQUE_SELLING_POINT',
  Warning = 'WARNING',
}

export type TriplePlayHowItWorks = {
  __typename?: 'HowItWorks';
  id: TriplePlayScalars['UUID'];
  entityType: TriplePlayScalars['String'];
  creationDateTime?: TriplePlayMaybe<TriplePlayScalars['DateTime']>;
  lastModifiedBy?: TriplePlayMaybe<TriplePlayScalars['String']>;
  lastModifiedDateTime?: TriplePlayMaybe<TriplePlayScalars['DateTime']>;
  TriplePlayProductCategory: TriplePlayProductCategory;
  clientName?: TriplePlayMaybe<TriplePlayScalars['String']>;
  typeName: TriplePlayScalars['String'];
  value: TriplePlayScalars['String'];
  version?: TriplePlayMaybe<TriplePlayScalars['Int']>;
};

export enum TriplePlayPorMaa {
  Va003 = 'VA003',
  Va009 = 'VA009',
  Va010 = 'VA010',
  Va011 = 'VA011',
  Va012 = 'VA012',
  Va014 = 'VA014',
  Va015 = 'VA015',
  Va016 = 'VA016',
  Va019 = 'VA019',
  Va030 = 'VA030',
  Va032 = 'VA032',
  Va038 = 'VA038',
  Va043 = 'VA043',
  Va044 = 'VA044',
  Va045 = 'VA045',
  Va048 = 'VA048',
  Va051 = 'VA051',
  Va053 = 'VA053',
  Va054 = 'VA054',
  Va055 = 'VA055',
  Va057 = 'VA057',
  Va059 = 'VA059',
  Va062 = 'VA062',
  Va065 = 'VA065',
  Va107 = 'VA107',
  Va113 = 'VA113',
  Va120 = 'VA120',
  Va121 = 'VA121',
  Va123 = 'VA123',
  Va126 = 'VA126',
  Va132 = 'VA132',
  Va136 = 'VA136',
  Va138 = 'VA138',
  Va204 = 'VA204',
  Va504 = 'VA504',
  Va515 = 'VA515',
  Va548 = 'VA548',
  Va549 = 'VA549',
  Va550 = 'VA550',
  Va702 = 'VA702',
  Va711 = 'VA711',
  Va712 = 'VA712',
  Va719 = 'VA719',
  Va722 = 'VA722',
  Va724 = 'VA724',
  Va731 = 'VA731',
  Va746 = 'VA746',
  Va747 = 'VA747',
  Va752 = 'VA752',
  Va753 = 'VA753',
  Va754 = 'VA754',
  Va756 = 'VA756',
  Va757 = 'VA757',
  Va758 = 'VA758',
  Va759 = 'VA759',
  Va760 = 'VA760',
  Va761 = 'VA761',
  Va762 = 'VA762',
  Va888 = 'VA888',
  Vb013 = 'VB013',
  Vb019 = 'VB019',
  Vb025 = 'VB025',
  Vb033 = 'VB033',
  Vb037 = 'VB037',
  Vb039 = 'VB039',
  Vb507 = 'VB507',
  Vb707 = 'VB707',
  Vb708 = 'VB708',
  Vb711 = 'VB711',
  Vb714 = 'VB714',
  Vb746 = 'VB746',
  Vb747 = 'VB747',
  Vb748 = 'VB748',
  Vb756 = 'VB756',
  Vb764 = 'VB764',
  Vb778 = 'VB778',
  Vb787 = 'VB787',
  Vb801 = 'VB801',
  Vb812 = 'VB812',
  Vb813 = 'VB813',
  Vb816 = 'VB816',
  Vb819 = 'VB819',
  Vb822 = 'VB822',
  Vc002 = 'VC002',
  Vc003 = 'VC003',
  Vc004 = 'VC004',
  Vc009 = 'VC009',
  Vc024 = 'VC024',
  Vc027 = 'VC027',
  Vc030 = 'VC030',
  Vc037 = 'VC037',
  Vc039 = 'VC039',
  Vc051 = 'VC051',
  Vc052 = 'VC052',
  Vc053 = 'VC053',
  Vc502 = 'VC502',
  Vc505 = 'VC505',
  Vc507 = 'VC507',
  Vc511 = 'VC511',
  Vc703 = 'VC703',
  Vc706 = 'VC706',
  Vc708 = 'VC708',
  Vc709 = 'VC709',
  Vc724 = 'VC724',
  Vc726 = 'VC726',
  Vc727 = 'VC727',
  Vc728 = 'VC728',
  Vc740 = 'VC740',
  Vc750 = 'VC750',
  Vc751 = 'VC751',
  Vd003 = 'VD003',
  Vd004 = 'VD004',
  Vd006 = 'VD006',
  Vd007 = 'VD007',
  Vd009 = 'VD009',
  Vd016 = 'VD016',
  Vd022 = 'VD022',
  Vd047 = 'VD047',
  Vd051 = 'VD051',
  Vd054 = 'VD054',
  Vd055 = 'VD055',
  Vd056 = 'VD056',
  Vd057 = 'VD057',
  Vd703 = 'VD703',
  Vd705 = 'VD705',
  Vd706 = 'VD706',
  Vd707 = 'VD707',
  Vd710 = 'VD710',
  Vd716 = 'VD716',
  Vd720 = 'VD720',
  Vd721 = 'VD721',
  Vd722 = 'VD722',
  Vd724 = 'VD724',
  Vd726 = 'VD726',
  Vd727 = 'VD727',
  Vd730 = 'VD730',
  Vd731 = 'VD731',
  Vd741 = 'VD741',
  Vd742 = 'VD742',
  Vd743 = 'VD743',
  Vd745 = 'VD745',
  Vd746 = 'VD746',
  Vd747 = 'VD747',
  Ve001 = 'VE001',
  Ve006 = 'VE006',
  Ve008 = 'VE008',
  Ve009 = 'VE009',
  Ve028 = 'VE028',
  Ve030 = 'VE030',
  Ve035 = 'VE035',
  Ve081 = 'VE081',
  Ve085 = 'VE085',
  Ve087 = 'VE087',
  Ve101 = 'VE101',
  Ve102 = 'VE102',
  Ve103 = 'VE103',
  Ve505 = 'VE505',
  Ve510 = 'VE510',
  Ve515 = 'VE515',
  Ve701 = 'VE701',
  Ve709 = 'VE709',
  Ve723 = 'VE723',
  Ve731 = 'VE731',
  Ve734 = 'VE734',
  Ve744 = 'VE744',
  Ve746 = 'VE746',
  Vf001 = 'VF001',
  Vf003 = 'VF003',
  Vf004 = 'VF004',
  Vf505 = 'VF505',
  Vf506 = 'VF506',
  Vf703 = 'VF703',
  Vf706 = 'VF706',
  Vf710 = 'VF710',
  Vf713 = 'VF713',
  Vf714 = 'VF714',
  Vf720 = 'VF720',
  Vg001 = 'VG001',
  Vg006 = 'VG006',
  Vg012 = 'VG012',
  Vg013 = 'VG013',
  Vg015 = 'VG015',
  Vg019 = 'VG019',
  Vg029 = 'VG029',
  Vg036 = 'VG036',
  Vg507 = 'VG507',
  Vg705 = 'VG705',
  Vg708 = 'VG708',
  Vg713 = 'VG713',
  Vg716 = 'VG716',
  Vg720 = 'VG720',
  Vg725 = 'VG725',
  Vg726 = 'VG726',
  Vg728 = 'VG728',
  Vg731 = 'VG731',
  Vg734 = 'VG734',
  Vg737 = 'VG737',
  Vg741 = 'VG741',
  Vg742 = 'VG742',
  Vh004 = 'VH004',
  Vh008 = 'VH008',
  Vh034 = 'VH034',
  Vh039 = 'VH039',
  Vh041 = 'VH041',
  Vh043 = 'VH043',
  Vh044 = 'VH044',
  Vh048 = 'VH048',
  Vh060 = 'VH060',
  Vh506 = 'VH506',
  Vh520 = 'VH520',
  Vh521 = 'VH521',
  Vh708 = 'VH708',
  Vh709 = 'VH709',
  Vh710 = 'VH710',
  Vh716 = 'VH716',
  Vh717 = 'VH717',
  Vh718 = 'VH718',
  Vh720 = 'VH720',
  Vh724 = 'VH724',
  Vh725 = 'VH725',
  Vh726 = 'VH726',
  Vh730 = 'VH730',
  Vh742 = 'VH742',
  Vh749 = 'VH749',
  Vh760 = 'VH760',
  Vh761 = 'VH761',
  Vh768 = 'VH768',
  Vh773 = 'VH773',
  Vh774 = 'VH774',
  Vh782 = 'VH782',
  Vh783 = 'VH783',
  Vh792 = 'VH792',
  Vh793 = 'VH793',
  Vh794 = 'VH794',
  Vh795 = 'VH795',
  Vi004 = 'VI004',
  Vi005 = 'VI005',
  Vi008 = 'VI008',
  Vi009 = 'VI009',
  Vi011 = 'VI011',
  Vi016 = 'VI016',
  Vi017 = 'VI017',
  Vi018 = 'VI018',
  Vi518 = 'VI518',
  Vi702 = 'VI702',
  Vi708 = 'VI708',
  Vi709 = 'VI709',
  Vi715 = 'VI715',
  Vi716 = 'VI716',
  Vi718 = 'VI718',
  Vi726 = 'VI726',
  Vi727 = 'VI727',
  Vi728 = 'VI728',
  Vi927 = 'VI927',
  Vj015 = 'VJ015',
  Vj705 = 'VJ705',
  Vj731 = 'VJ731',
  Vj733 = 'VJ733',
  Vj740 = 'VJ740',
  Vk009 = 'VK009',
  Vk011 = 'VK011',
  Vk012 = 'VK012',
  Vk015 = 'VK015',
  Vk026 = 'VK026',
  Vk504 = 'VK504',
  Vk703 = 'VK703',
  Vk705 = 'VK705',
  Vk720 = 'VK720',
  Vk723 = 'VK723',
  Vk729 = 'VK729',
  Vk745 = 'VK745',
  Vk756 = 'VK756',
  Vk759 = 'VK759',
  Vk780 = 'VK780',
  Vk781 = 'VK781',
  Vk791 = 'VK791',
  Vk796 = 'VK796',
  Vk799 = 'VK799',
  Vk801 = 'VK801',
  Vk809 = 'VK809',
  Vk812 = 'VK812',
  Vk815 = 'VK815',
  Vk819 = 'VK819',
  Vk822 = 'VK822',
  Vk823 = 'VK823',
  Vl006 = 'VL006',
  Vl007 = 'VL007',
  Vl008 = 'VL008',
  Vl009 = 'VL009',
  Vl011 = 'VL011',
  Vl012 = 'VL012',
  Vl014 = 'VL014',
  Vl016 = 'VL016',
  Vl025 = 'VL025',
  Vl030 = 'VL030',
  Vl031 = 'VL031',
  Vl032 = 'VL032',
  Vl507 = 'VL507',
  Vl514 = 'VL514',
  Vl517 = 'VL517',
  Vl705 = 'VL705',
  Vl715 = 'VL715',
  Vl719 = 'VL719',
  Vl720 = 'VL720',
  Vl721 = 'VL721',
  Vl733 = 'VL733',
  Vl744 = 'VL744',
  Vl748 = 'VL748',
  Vl752 = 'VL752',
  Vl763 = 'VL763',
  Vl765 = 'VL765',
  Vl768 = 'VL768',
  Vl771 = 'VL771',
  Vl775 = 'VL775',
  Vm002 = 'VM002',
  Vm016 = 'VM016',
  Vm018 = 'VM018',
  Vm019 = 'VM019',
  Vm027 = 'VM027',
  Vm029 = 'VM029',
  Vm041 = 'VM041',
  Vm043 = 'VM043',
  Vm516 = 'VM516',
  Vm532 = 'VM532',
  Vm701 = 'VM701',
  Vm702 = 'VM702',
  Vm707 = 'VM707',
  Vm712 = 'VM712',
  Vm717 = 'VM717',
  Vm728 = 'VM728',
  Vm730 = 'VM730',
  Vm731 = 'VM731',
  Vm740 = 'VM740',
  Vm743 = 'VM743',
  Vm746 = 'VM746',
  Vm747 = 'VM747',
  Vm750 = 'VM750',
  Vm751 = 'VM751',
  Vm755 = 'VM755',
  Vm760 = 'VM760',
  Vm763 = 'VM763',
  Vm764 = 'VM764',
  Vm766 = 'VM766',
  Vmma1 = 'VMMA1',
  Vn002 = 'VN002',
  Vn004 = 'VN004',
  Vn005 = 'VN005',
  Vn007 = 'VN007',
  Vn013 = 'VN013',
  Vn014 = 'VN014',
  Vn015 = 'VN015',
  Vn017 = 'VN017',
  Vn019 = 'VN019',
  Vn026 = 'VN026',
  Vn043 = 'VN043',
  Vn051 = 'VN051',
  Vn053 = 'VN053',
  Vn069 = 'VN069',
  Vn083 = 'VN083',
  Vn096 = 'VN096',
  Vn113 = 'VN113',
  Vn119 = 'VN119',
  Vn121 = 'VN121',
  Vn131 = 'VN131',
  Vn134 = 'VN134',
  Vn137 = 'VN137',
  Vn139 = 'VN139',
  Vn141 = 'VN141',
  Vn143 = 'VN143',
  Vn146 = 'VN146',
  Vn514 = 'VN514',
  Vn532 = 'VN532',
  Vn705 = 'VN705',
  Vn711 = 'VN711',
  Vn719 = 'VN719',
  Vn727 = 'VN727',
  Vn728 = 'VN728',
  Vn736 = 'VN736',
  Vn737 = 'VN737',
  Vn738 = 'VN738',
  Vn739 = 'VN739',
  Vn740 = 'VN740',
  Vn741 = 'VN741',
  Vo002 = 'VO002',
  Vo003 = 'VO003',
  Vo004 = 'VO004',
  Vo006 = 'VO006',
  Vo013 = 'VO013',
  Vo026 = 'VO026',
  Vo027 = 'VO027',
  Vo028 = 'VO028',
  Vo029 = 'VO029',
  Vo035 = 'VO035',
  Vo037 = 'VO037',
  Vo039 = 'VO039',
  Vo054 = 'VO054',
  Vo063 = 'VO063',
  Vo083 = 'VO083',
  Vo102 = 'VO102',
  Vo104 = 'VO104',
  Vo109 = 'VO109',
  Vo118 = 'VO118',
  Vo124 = 'VO124',
  Vo132 = 'VO132',
  Vo140 = 'VO140',
  Vo705 = 'VO705',
  Vo706 = 'VO706',
  Vo710 = 'VO710',
  Vo717 = 'VO717',
  Vo722 = 'VO722',
  Vo730 = 'VO730',
  Vp009 = 'VP009',
  Vp020 = 'VP020',
  Vp021 = 'VP021',
  Vp024 = 'VP024',
  Vp028 = 'VP028',
  Vp030 = 'VP030',
  Vp032 = 'VP032',
  Vp033 = 'VP033',
  Vp034 = 'VP034',
  Vp519 = 'VP519',
  Vp706 = 'VP706',
  Vp709 = 'VP709',
  Vp712 = 'VP712',
  Vp728 = 'VP728',
  Vp732 = 'VP732',
  Vp737 = 'VP737',
  Vp738 = 'VP738',
  Vp739 = 'VP739',
  Vp740 = 'VP740',
  Vq703 = 'VQ703',
  Vr003 = 'VR003',
  Vr004 = 'VR004',
  Vr005 = 'VR005',
  Vr012 = 'VR012',
  Vr016 = 'VR016',
  Vr021 = 'VR021',
  Vr023 = 'VR023',
  Vr025 = 'VR025',
  Vr032 = 'VR032',
  Vr033 = 'VR033',
  Vr510 = 'VR510',
  Vr514 = 'VR514',
  Vr515 = 'VR515',
  Vr702 = 'VR702',
  Vr703 = 'VR703',
  Vr705 = 'VR705',
  Vr710 = 'VR710',
  Vr712 = 'VR712',
  Vr714 = 'VR714',
  Vr718 = 'VR718',
  Vr720 = 'VR720',
  Vr721 = 'VR721',
  Vr724 = 'VR724',
  Vr726 = 'VR726',
  Vr728 = 'VR728',
  Vr734 = 'VR734',
  Vr736 = 'VR736',
  Vr738 = 'VR738',
  Vr739 = 'VR739',
  Vr743 = 'VR743',
  Vr745 = 'VR745',
  Vs002 = 'VS002',
  Vs003 = 'VS003',
  Vs004 = 'VS004',
  Vs006 = 'VS006',
  Vs007 = 'VS007',
  Vs010 = 'VS010',
  Vs011 = 'VS011',
  Vs017 = 'VS017',
  Vs030 = 'VS030',
  Vs041 = 'VS041',
  Vs042 = 'VS042',
  Vs045 = 'VS045',
  Vs046 = 'VS046',
  Vs071 = 'VS071',
  Vs073 = 'VS073',
  Vs082 = 'VS082',
  Vs087 = 'VS087',
  Vs536 = 'VS536',
  Vs539 = 'VS539',
  Vs700 = 'VS700',
  Vs702 = 'VS702',
  Vs704 = 'VS704',
  Vs706 = 'VS706',
  Vs707 = 'VS707',
  Vs709 = 'VS709',
  Vs710 = 'VS710',
  Vs714 = 'VS714',
  Vs715 = 'VS715',
  Vs725 = 'VS725',
  Vs729 = 'VS729',
  Vs739 = 'VS739',
  Vs747 = 'VS747',
  Vs752 = 'VS752',
  Vs760 = 'VS760',
  Vs777 = 'VS777',
  Vs778 = 'VS778',
  Vs779 = 'VS779',
  Vs786 = 'VS786',
  Vs787 = 'VS787',
  Vs789 = 'VS789',
  Vs790 = 'VS790',
  Vs795 = 'VS795',
  Vs796 = 'VS796',
  Vs797 = 'VS797',
  Vs802 = 'VS802',
  Vs803 = 'VS803',
  Vt003 = 'VT003',
  Vt009 = 'VT009',
  Vt018 = 'VT018',
  Vt021 = 'VT021',
  Vt501 = 'VT501',
  Vt508 = 'VT508',
  Vt701 = 'VT701',
  Vt711 = 'VT711',
  Vt717 = 'VT717',
  Vt720 = 'VT720',
  Vt734 = 'VT734',
  Vt740 = 'VT740',
  Vt741 = 'VT741',
  Vt744 = 'VT744',
  Vt745 = 'VT745',
  Vt746 = 'VT746',
  Vu002 = 'VU002',
  Vu005 = 'VU005',
  Vu014 = 'VU014',
  Vu018 = 'VU018',
  Vu019 = 'VU019',
  Vu020 = 'VU020',
  Vu703 = 'VU703',
  Vu705 = 'VU705',
  Vu708 = 'VU708',
  Vu710 = 'VU710',
  Vu711 = 'VU711',
  Vu713 = 'VU713',
  Vu714 = 'VU714',
  Vv005 = 'VV005',
  Vv010 = 'VV010',
  Vv013 = 'VV013',
  Vv037 = 'VV037',
  Vv039 = 'VV039',
  Vv045 = 'VV045',
  Vv055 = 'VV055',
  Vv056 = 'VV056',
  Vv100 = 'VV100',
  Vv102 = 'VV102',
  Vv703 = 'VV703',
  Vv705 = 'VV705',
  Vv706 = 'VV706',
  Vv707 = 'VV707',
  Vv708 = 'VV708',
  Vv709 = 'VV709',
  Vv724 = 'VV724',
  Vv726 = 'VV726',
  Vv731 = 'VV731',
  Vv733 = 'VV733',
  Vv735 = 'VV735',
  Vv736 = 'VV736',
  Vv740 = 'VV740',
  Vv750 = 'VV750',
  Vv751 = 'VV751',
  Vv755 = 'VV755',
  Vv758 = 'VV758',
  Vv759 = 'VV759',
  Vv764 = 'VV764',
  Vv767 = 'VV767',
  Vv771 = 'VV771',
  Vv781 = 'VV781',
  Vv783 = 'VV783',
  Vv784 = 'VV784',
  Vv785 = 'VV785',
  Vv786 = 'VV786',
  Vv787 = 'VV787',
  Vvbv1 = 'VVBV1',
  Vw014 = 'VW014',
  Vw015 = 'VW015',
  Vw027 = 'VW027',
  Vw033 = 'VW033',
  Vw506 = 'VW506',
  Vw507 = 'VW507',
  Vw705 = 'VW705',
  Vw707 = 'VW707',
  Vw711 = 'VW711',
  Vw712 = 'VW712',
  Vw721 = 'VW721',
  Vw727 = 'VW727',
  Vw731 = 'VW731',
  Vw740 = 'VW740',
  Vw741 = 'VW741',
  Vw999 = 'VW999',
  Vx001 = 'VX001',
  Vx002 = 'VX002',
  Vx003 = 'VX003',
  Vx006 = 'VX006',
  Vx008 = 'VX008',
  Vx978 = 'VX978',
  Vy501 = 'VY501',
  Vy709 = 'VY709',
  Vz030 = 'VZ030',
  Vz033 = 'VZ033',
  Vz053 = 'VZ053',
  Vz505 = 'VZ505',
  Vz506 = 'VZ506',
  Vz706 = 'VZ706',
  Vz707 = 'VZ707',
  Vzn01 = 'VZN01',
}

export enum TriplePlayAdnAdr {
  V001 = 'V001',
  V002 = 'V002',
  V003 = 'V003',
  V004 = 'V004',
  V013 = 'V013',
  V014 = 'V014',
  V015 = 'V015',
  V016 = 'V016',
  V017 = 'V017',
}

export enum TriplePlayIsoLan {
  Vad = 'VAD',
  Vae = 'VAE',
  Vaf = 'VAF',
  Vag = 'VAG',
  Vai = 'VAI',
  Val = 'VAL',
  Vam = 'VAM',
  Van = 'VAN',
  Vao = 'VAO',
  Vaq = 'VAQ',
  Var = 'VAR',
  Vas = 'VAS',
  Vat = 'VAT',
  Vau = 'VAU',
  Vaw = 'VAW',
  Vax = 'VAX',
  Vaz = 'VAZ',
  Vba = 'VBA',
  Vbb = 'VBB',
  Vbd = 'VBD',
  Vbe = 'VBE',
  Vbf = 'VBF',
  Vbg = 'VBG',
  Vbh = 'VBH',
  Vbi = 'VBI',
  Vbj = 'VBJ',
  Vbl = 'VBL',
  Vbm = 'VBM',
  Vbn = 'VBN',
  Vbo = 'VBO',
  Vbq = 'VBQ',
  Vbr = 'VBR',
  Vbs = 'VBS',
  Vbt = 'VBT',
  Vbv = 'VBV',
  Vbw = 'VBW',
  Vby = 'VBY',
  Vbz = 'VBZ',
  Vca = 'VCA',
  Vcc = 'VCC',
  Vcd = 'VCD',
  Vcf = 'VCF',
  Vcg = 'VCG',
  Vch = 'VCH',
  Vci = 'VCI',
  Vck = 'VCK',
  Vcl = 'VCL',
  Vcm = 'VCM',
  Vcn = 'VCN',
  Vco = 'VCO',
  Vcr = 'VCR',
  Vcs = 'VCS',
  Vcu = 'VCU',
  Vcv = 'VCV',
  Vcw = 'VCW',
  Vcx = 'VCX',
  Vcy = 'VCY',
  Vcz = 'VCZ',
  Vde = 'VDE',
  Vdj = 'VDJ',
  Vdk = 'VDK',
  Vdm = 'VDM',
  Vdo = 'VDO',
  Vdz = 'VDZ',
  Vec = 'VEC',
  Vee = 'VEE',
  Veg = 'VEG',
  Veh = 'VEH',
  Ver = 'VER',
  Ves = 'VES',
  Vet = 'VET',
  Vfi = 'VFI',
  Vfj = 'VFJ',
  Vfk = 'VFK',
  Vfm = 'VFM',
  Vfo = 'VFO',
  Vfr = 'VFR',
  Vga = 'VGA',
  Vgb = 'VGB',
  Vgd = 'VGD',
  Vge = 'VGE',
  Vgf = 'VGF',
  Vgg = 'VGG',
  Vgh = 'VGH',
  Vgi = 'VGI',
  Vgl = 'VGL',
  Vgm = 'VGM',
  Vgn = 'VGN',
  Vgp = 'VGP',
  Vgq = 'VGQ',
  Vgr = 'VGR',
  Vgs = 'VGS',
  Vgt = 'VGT',
  Vgu = 'VGU',
  Vgw = 'VGW',
  Vgy = 'VGY',
  Vhk = 'VHK',
  Vhm = 'VHM',
  Vhn = 'VHN',
  Vhr = 'VHR',
  Vht = 'VHT',
  Vhu = 'VHU',
  Vid = 'VID',
  Vie = 'VIE',
  Vil = 'VIL',
  Vim = 'VIM',
  Vin = 'VIN',
  Vio = 'VIO',
  Viq = 'VIQ',
  Vir = 'VIR',
  Vis = 'VIS',
  Vit = 'VIT',
  Vje = 'VJE',
  Vjm = 'VJM',
  Vjo = 'VJO',
  Vjp = 'VJP',
  Vke = 'VKE',
  Vkg = 'VKG',
  Vkh = 'VKH',
  Vki = 'VKI',
  Vkm = 'VKM',
  Vkn = 'VKN',
  Vkp = 'VKP',
  Vkr = 'VKR',
  Vkw = 'VKW',
  Vky = 'VKY',
  Vkz = 'VKZ',
  Vla = 'VLA',
  Vlb = 'VLB',
  Vlc = 'VLC',
  Vli = 'VLI',
  Vlk = 'VLK',
  Vlr = 'VLR',
  Vls = 'VLS',
  Vlt = 'VLT',
  Vlu = 'VLU',
  Vlv = 'VLV',
  Vly = 'VLY',
  Vma = 'VMA',
  Vmc = 'VMC',
  Vmd = 'VMD',
  Vme = 'VME',
  Vmf = 'VMF',
  Vmg = 'VMG',
  Vmh = 'VMH',
  Vmk = 'VMK',
  Vml = 'VML',
  Vmm = 'VMM',
  Vmn = 'VMN',
  Vmo = 'VMO',
  Vmp = 'VMP',
  Vmq = 'VMQ',
  Vmr = 'VMR',
  Vms = 'VMS',
  Vmt = 'VMT',
  Vmu = 'VMU',
  Vmv = 'VMV',
  Vmw = 'VMW',
  Vmx = 'VMX',
  Vmy = 'VMY',
  Vmz = 'VMZ',
  Vna = 'VNA',
  Vnc = 'VNC',
  Vne = 'VNE',
  Vnf = 'VNF',
  Vng = 'VNG',
  Vni = 'VNI',
  Vnl = 'VNL',
  Vno = 'VNO',
  Vnp = 'VNP',
  Vnr = 'VNR',
  Vnu = 'VNU',
  Vnz = 'VNZ',
  Vom = 'VOM',
  Vpa = 'VPA',
  Vpe = 'VPE',
  Vpf = 'VPF',
  Vpg = 'VPG',
  Vph = 'VPH',
  Vpk = 'VPK',
  Vpl = 'VPL',
  Vpm = 'VPM',
  Vpn = 'VPN',
  Vpr = 'VPR',
  Vps = 'VPS',
  Vpt = 'VPT',
  Vpw = 'VPW',
  Vpy = 'VPY',
  Vqa = 'VQA',
  Vre = 'VRE',
  Vro = 'VRO',
  Vrs = 'VRS',
  Vru = 'VRU',
  Vrw = 'VRW',
  Vsa = 'VSA',
  Vsb = 'VSB',
  Vsc = 'VSC',
  Vsd = 'VSD',
  Vse = 'VSE',
  Vsg = 'VSG',
  Vsh = 'VSH',
  Vsi = 'VSI',
  Vsj = 'VSJ',
  Vsk = 'VSK',
  Vsl = 'VSL',
  Vsm = 'VSM',
  Vsn = 'VSN',
  Vso = 'VSO',
  Vsr = 'VSR',
  Vss = 'VSS',
  Vst = 'VST',
  Vsv = 'VSV',
  Vsx = 'VSX',
  Vsy = 'VSY',
  Vsz = 'VSZ',
  Vtc = 'VTC',
  Vtd = 'VTD',
  Vtf = 'VTF',
  Vtg = 'VTG',
  Vth = 'VTH',
  Vtj = 'VTJ',
  Vtk = 'VTK',
  Vtl = 'VTL',
  Vtm = 'VTM',
  Vtn = 'VTN',
  Vto = 'VTO',
  Vtr = 'VTR',
  Vtt = 'VTT',
  Vtv = 'VTV',
  Vtw = 'VTW',
  Vtz = 'VTZ',
  Vua = 'VUA',
  Vug = 'VUG',
  Vum = 'VUM',
  Vus = 'VUS',
  Vuy = 'VUY',
  Vuz = 'VUZ',
  Vva = 'VVA',
  Vvc = 'VVC',
  Vve = 'VVE',
  Vvg = 'VVG',
  Vvi = 'VVI',
  Vvn = 'VVN',
  Vvu = 'VVU',
  Vwf = 'VWF',
  Vws = 'VWS',
  Vye = 'VYE',
  Vyt = 'VYT',
  Vza = 'VZA',
  Vzm = 'VZM',
  Vzw = 'VZW',
  Vzz = 'VZZ',
}

export type TriplePlayFeature = {
  __typename?: 'Feature';
  name: TriplePlayScalars['String'];
  value: TriplePlayScalars['String'];
  TriplePlayProductCategory: TriplePlayProductCategory;
};

export type TriplePlayTaskDivision = {
  __typename?: 'TaskDivision';
  id: TriplePlayScalars['UUID'];
  entityType: TriplePlayScalars['String'];
  creationDateTime?: TriplePlayMaybe<TriplePlayScalars['DateTime']>;
  lastModifiedBy?: TriplePlayMaybe<TriplePlayScalars['String']>;
  lastModifiedDateTime?: TriplePlayMaybe<TriplePlayScalars['DateTime']>;
  TriplePlayProductCategory: TriplePlayProductCategory;
  clientName?: TriplePlayMaybe<TriplePlayScalars['String']>;
  name: TriplePlayScalars['String'];
  value?: TriplePlayMaybe<TriplePlayScalars['String']>;
  version?: TriplePlayMaybe<TriplePlayScalars['Int']>;
};

export enum TriplePlayProductCategory {
  NonSpecific = 'NON_SPECIFIC',
  Car = 'CAR',
  Energy = 'ENERGY',
  Home = 'HOME',
  Liability = 'LIABILITY',
  TriplePlay = 'TRIPLE_PLAY',
  Travel = 'TRAVEL',
}

export type TriplePlayProOrCon = {
  __typename?: 'ProOrCon';
  description: TriplePlayScalars['String'];
  TriplePlayProductCategory: TriplePlayProductCategory;
  clientName: TriplePlayScalars['String'];
};

export enum TriplePlayInformationContactType {
  CustomerSales = 'CUSTOMER_SALES',
  Information = 'INFORMATION',
}

export type TriplePlayInformationContact = {
  __typename?: 'InformationContact';
  id: TriplePlayScalars['UUID'];
  type: TriplePlayInformationContactType;
  replyNumber?: TriplePlayMaybe<TriplePlayScalars['String']>;
  phoneNumber?: TriplePlayMaybe<TriplePlayScalars['String']>;
  emailAddress?: TriplePlayMaybe<TriplePlayScalars['String']>;
};

export type TriplePlayAddress = {
  __typename?: 'Address';
  id: TriplePlayScalars['UUID'];
  addressType?: TriplePlayMaybe<TriplePlayAdnAdr>;
  city?: TriplePlayMaybe<TriplePlayScalars['String']>;
  country?: TriplePlayMaybe<TriplePlayIsoLan>;
  houseNumber?: TriplePlayMaybe<TriplePlayScalars['Int']>;
  houseNumberAddition?: TriplePlayMaybe<TriplePlayScalars['String']>;
  houseLetter?: TriplePlayMaybe<TriplePlayScalars['String']>;
  postalCode?: TriplePlayMaybe<TriplePlayScalars['String']>;
  street?: TriplePlayMaybe<TriplePlayScalars['String']>;
};

export enum TriplePlayProductSupplierState {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Hidden = 'HIDDEN',
  Inactive = 'INACTIVE',
}

export type TriplePlayProductSupplier = {
  __typename?: 'ProductSupplier';
  entityType: TriplePlayScalars['String'];
  refKey: TriplePlayScalars['UUID'];
  krn: TriplePlayScalars['String'];
  name: TriplePlayScalars['String'];
  legalName?: TriplePlayMaybe<TriplePlayScalars['String']>;
  externalIds?: TriplePlayMaybe<Array<TriplePlayProviderSupplier>>;
  porCompany?: TriplePlayMaybe<TriplePlayPorMaa>;
  state: TriplePlayProductSupplierState;
  nameLogoUrl?: TriplePlayMaybe<TriplePlayScalars['String']>;
  addresses?: TriplePlayMaybe<Array<TriplePlayAddress>>;
  informationContacts?: TriplePlayMaybe<Array<TriplePlayInformationContact>>;
  advantages?: TriplePlayMaybe<Array<TriplePlayProOrCon>>;
  disadvantages?: TriplePlayMaybe<Array<TriplePlayProOrCon>>;
  features?: TriplePlayMaybe<Array<TriplePlayFeature>>;
  taskDivisions?: TriplePlayMaybe<Array<TriplePlayTaskDivision>>;
  sustainabilityScore?: TriplePlayMaybe<Array<TriplePlaySustainabilityScore>>;
  sellingPoints?: TriplePlayMaybe<Array<TriplePlaySellingPoint>>;
  howItWorks?: TriplePlayMaybe<Array<TriplePlayHowItWorks>>;
  about?: TriplePlayMaybe<TriplePlayScalars['String']>;
  id: TriplePlayScalars['UUID'];
  version?: TriplePlayMaybe<TriplePlayScalars['Int']>;
  creationDateTime?: TriplePlayMaybe<TriplePlayScalars['DateTime']>;
  lastModifiedDateTime?: TriplePlayMaybe<TriplePlayScalars['DateTime']>;
  lastModifiedBy?: TriplePlayMaybe<TriplePlayScalars['String']>;
};

export type TriplePlayProviderSupplier = {
  __typename?: 'ProviderSupplier';
  providerKrn: TriplePlayScalars['String'];
  externalSupplierId: TriplePlayScalars['String'];
};
